import { render, staticRenderFns } from "./BonusCarburante.vue?vue&type=template&id=049cd964&scoped=true"
import script from "./BonusCarburante.vue?vue&type=script&lang=js"
export * from "./BonusCarburante.vue?vue&type=script&lang=js"
import style0 from "./BonusCarburante.vue?vue&type=style&index=0&id=049cd964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049cd964",
  null
  
)

export default component.exports